(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hamburger-sidebar"]) return;
  try {
    
(function() {
  // Check if we're on shipping policy or about us page and hide hamburger
  const currentPath = window.location.pathname.toLowerCase();
  const pageTitle = document.title.toLowerCase();
  
  // Only hide on shipping policy and about us pages
  const shouldHideHamburger = (currentPath.includes('shipping') && currentPath.includes('policy')) ||
                              currentPath.includes('about-us') ||
                              currentPath.includes('/about') ||
                              (pageTitle.includes('shipping') && pageTitle.includes('policy')) ||
                              (pageTitle.includes('about us') || pageTitle.includes('about'));
  
  const hamburgerWrapper = document.querySelector('.hamburger-sidebar-wrapper');
  if (shouldHideHamburger && hamburgerWrapper) {
    hamburgerWrapper.style.display = 'none';
    return; // Exit early if on shipping policy or about us page
  }

  const hamburgerBtn = document.getElementById('hamburger-menu-btn');
  const sidebar = document.getElementById('hamburger-sidebar');
  const overlay = document.getElementById('sidebar-overlay');

  function openSidebar() {
    sidebar.classList.add('active');
    overlay.classList.add('active');
    hamburgerBtn.classList.add('active');
    document.body.classList.add('sidebar-open');
  }

  function closeSidebar() {
    sidebar.classList.remove('active');
    overlay.classList.remove('active');
    hamburgerBtn.classList.remove('active');
    document.body.classList.remove('sidebar-open');
  }

  function toggleSidebar() {
    if (sidebar.classList.contains('active')) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }

  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', toggleSidebar);
  }

  if (overlay) {
    overlay.addEventListener('click', closeSidebar);
  }

  // Close sidebar when clicking on a link (mobile-friendly)
  const sidebarLinks = sidebar.querySelectorAll('.sidebar-nav-link, .sidebar-subnav-link');
  sidebarLinks.forEach(link => {
    link.addEventListener('click', function() {
      // Small delay to allow navigation
      setTimeout(closeSidebar, 100);
    });
  });

  // Close sidebar on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sidebar.classList.contains('active')) {
      closeSidebar();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
